/**
 * @generated SignedSource<<578954082f38de2cbb47741c89214785>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TimeSig = "VALUE_UNSET" | "t12_8" | "t2_2" | "t2_4" | "t3_4" | "t4_4" | "t6_8" | "t9_8" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UpdateSongTimeSig_song$data = {
  readonly id: string;
  readonly mongoVersion: number;
  readonly timeSig: TimeSig;
  readonly " $fragmentType": "UpdateSongTimeSig_song";
};
export type UpdateSongTimeSig_song$key = {
  readonly " $data"?: UpdateSongTimeSig_song$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateSongTimeSig_song">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateSongTimeSig_song",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mongoVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeSig",
      "storageKey": null
    }
  ],
  "type": "Song",
  "abstractKey": null
};

(node as any).hash = "7dfd2b81d0b5ef280cc437f8a3a23baa";

export default node;
